// export const API_URL = 'http://192.168.0.106:8000/api'; 
export const API_URL = 'https://wazwan-backend-1.onrender.com/api'; 
